(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("react"), require("prop-types"), require("react-router-dom"));
	else if(typeof define === 'function' && define.amd)
		define(["react", "prop-types", "react-router-dom"], factory);
	else if(typeof exports === 'object')
		exports["react-breadcrumbs"] = factory(require("react"), require("prop-types"), require("react-router-dom"));
	else
		root["react-breadcrumbs"] = factory(root["React"], root["PropTypes"], root["ReactRouterDOM"]);
})(this, function(__WEBPACK_EXTERNAL_MODULE_1__, __WEBPACK_EXTERNAL_MODULE_2__, __WEBPACK_EXTERNAL_MODULE_34__) {
return 


// WEBPACK FOOTER //
// webpack/universalModuleDefinition